import Vue from 'vue';
import App from './App.vue';
import createVuetify from './plugins/vuetify';
import router from './router';
import axios from 'axios';
import store from './store';
import VueApexCharts from 'vue-apexcharts';

Vue.config.productionTip = false;

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

async function loadConfig() {
  const response = await fetch('/config.json');
  return response.json();
}

loadConfig().then((config) => {
  Vue.prototype.$config = config;

  const api = axios.create({
    baseURL: config.VUE_APP_BASE_URL,
    withCredentials: true,
  });

  api.interceptors.request.use(
    (reqConfig) => {
      const authToken = store.getters.token;
      if (authToken) {
        reqConfig.headers.Authorization = `Bearer ${authToken}`;
      }
      return reqConfig;
    },
    (err) => {
      return Promise.reject(err);
    }
  );

  api.interceptors.response.use(
    function (response) {
      if (
        (response.config.url.includes('GetFormElements') ||
          response.config.url.includes('GetGridHeaders')) &&
        !response.data.length
      ) {
        store.commit('setNotificationMessage', {
          type: 'warning',
          text: 'Table headers or form elements are missing',
        });
      }

      const data = response.data;

      if (
        !!data &&
        typeof data === 'object' &&
        'Value' in data &&
        'Msg' in data &&
        Object.keys(data).length === 2
      ) {
        if (data.Value < 0) {
          if (
            (response.config.url.includes('/salary/UpdateSalary') ||
              response.config.url.includes('/salary/InsertSalary')) &&
            (data.Value === -5000 || data.Value === -5010)
          )
            return response;

          let errorMsg = 'Something went wrong';
          if (data.Msg && data.Msg !== ' ') errorMsg = data.Msg;
          store.commit('setNotificationMessage', { type: 'error', text: errorMsg });
          return Promise.reject(new Error(errorMsg));
        }
      }
      return response;
    },

    function (error) {
      if (error.response && error.response.status == 401 && router.currentRoute.path != '/login') {
        console.log(error.response.status);
        router.push({ path: '/login' });
      }
      console.log(error);
      store.commit('setNotificationMessage', { type: 'error', text: error.message });
      return Promise.reject(error);
    }
  );

  Vue.prototype.$api = api;

  const vuetify = createVuetify(config);
  
  new Vue({
    vuetify,
    router,
    data: {
      token: null,
      currentMember: {
        membershipId: null,
        memberName: '',
      },
      currentPlan: null,
      currentPage: '',
    },

    mounted: function () {
      // load sessionStorage
      this.currentMember.membershipId = sessionStorage.getItem('membershipId');
      this.currentMember.memberName = sessionStorage.getItem('memberName');
    },

    store,
    render: (h) => h(App),
  }).$mount('#app');
});
